import { ReactNode, createContext, useContext } from "react";
import { Links, Positions, UseAssetPriceInUSD, UseIsPaused, UseQuotePrice } from "./types";

export interface PositionsPanelContext {
  positions: Positions;
  assetLogo: ReactNode;
  useAssetPriceInUSD: UseAssetPriceInUSD;
  useQuotePrice: UseQuotePrice;
  useIsPaused: UseIsPaused;
  links: Links;
  disabledCollateralDescription?: ReactNode;
  afterActionGroupSlot?: ReactNode;
}

export const PositionsPanelContext = createContext<PositionsPanelContext>(null!);

export const usePositionsPanelContext = () => {
  const context = useContext(PositionsPanelContext);

  if (!context) {
    throw new Error("PositionsPanelContext is null. This hook can only be used within the PositionsPanel component.");
  }

  return context;
};
